// extracted by mini-css-extract-plugin
export default {"deletePopover":"styles__deletePopover___GKnlM"};